import dowellLogo from "./images/dowellLogo.png";
import contentLogo from "./images/contentLogo.png";
import { IoMdQuote } from "react-icons/io";
import { MdOutlineStarRate } from "react-icons/md";
import {
  HStack,
  Box,
  Icon,
  Flex,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

const Testimonials = ({ dataSection }) => {
  const txtColor2 = useColorModeValue("black", "white");
  return (
    <Box p={{ base: "15px", lg: "70px" }}>
      <Text
        fontSize="3xl"
        color="teal.500"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        mt={{ base: "20px", lg: "0px" }}
      >
        Testimonials
      </Text>
      <Text
        fontSize="sm"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        color={txtColor2}
        mb={15}
      >
        What Clients Say
      </Text>

      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ base: "column", md: "row", lg: "row" }}
        gap={6}
        my="70px"
      >
        <Box
          p="20px"
          w={{ base: "250px", sm: "400px", md: "450px", lg: "450px" }}
          bg="teal.800"
          mb={{ base: "50px", lg: "0px" }}
          borderRadius="10px"
          h="300px"
          position="relative"
        >
          <Flex justifyContent="space-between">
            <Icon as={IoMdQuote} color="orange.400" />
            <HStack>
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
            </HStack>
          </Flex>
          <Text color="white" my="20px">
            "Balogun presented himself as good and responsible developer, always
            was ready to take a new task and was online for discussions."
          </Text>
          <Flex
            mt={{ base: "55px", md: "50px", lg: "70px" }}
            position="absolute"
            bottom={2}
          >
            <Image
              w={{ base: "80px", md: "70px", lg: "70px" }}
              h={{ base: "80px", sm: "20%", md: "20%", lg: "20%" }}
              src={contentLogo}
              mt={{ base: 0, sm: 2, md: 5, lg: 5 }}
            />
            <Box ml="10px" mt="20px">
              <Text color="#e6e6e6">Content Office</Text>
              <Text fontSize={{ base: "10px", sm: "sm" }} color="white">
                Backend developer(NodeJs,Firebase)
              </Text>
            </Box>
          </Flex>
        </Box>
        <Box
          p="20px"
          w={{ base: "250px", sm: "400px", md: "450px", lg: "450px" }}
          bg="teal.800"
          mb={{ base: "50px", lg: "0px" }}
          borderRadius="10px"
          h="300px"
          position="relative"
        >
          <Flex justifyContent="space-between">
            <Icon as={IoMdQuote} color="orange.400" />
            <HStack>
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
              <Icon as={MdOutlineStarRate} color="orange.400" />
            </HStack>
          </Flex>
          <Text color="white" my="20px">
            "Great working experience with this seller !! He is great in his
            niche !"
          </Text>
          <Flex
            mt={{ base: "55px", md: "100px", lg: "90px" }}
            position="absolute"
            bottom={2}
          >
            <Image
              w={{ base: "80px", md: "70px" }}
              h={{ base: "80px", sm: "20%", md: "20%", lg: "20%" }}
              src={dowellLogo}
              mt={{ base: 0, sm: 2, md: 5, lg: 5 }}
            />
            <Box ml="10px" mt="20px">
              <Text color="white">Dowell Research</Text>
              <Text fontSize={{ base: "10px", sm: "sm" }} color="white">
                Backend developer(Django)
              </Text>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonials;
